import type { SectionKey } from '../prompts';
import type { Locale } from '../i18n';

export interface GenerateOptions {
  section: SectionKey | 'reply' | 'test';
  prompt: string;
  context?: string;
  locale?: Locale;
}

export interface GenerateResult {
  section: string;
  content: string;
  apiType?: string;
  model?: string;
  error?: string;
  code?: 'PLAN_LIMIT' | 'UPGRADE_REQUIRED';
}

export class GenerationError extends Error {
  code?: 'PLAN_LIMIT' | 'UPGRADE_REQUIRED';
  constructor(message: string, code?: 'PLAN_LIMIT' | 'UPGRADE_REQUIRED') {
    super(message);
    this.name = 'GenerationError';
    this.code = code;
  }
}

export async function generateContent(options: GenerateOptions): Promise<GenerateResult> {
  const response = await fetch('/api/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
  });

  const data = (await response.json()) as GenerateResult;

  if (!response.ok) {
    throw new GenerationError(data.error || `Request failed: ${response.status}`, data.code);
  }

  return data;
}

export async function generateReply(options: { prompt: string; context: string; locale?: Locale }): Promise<{ content: string }> {
  const response = await fetch('/api/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ section: 'reply', ...options }),
  });

  const data = (await response.json()) as GenerateResult;

  if (!response.ok) {
    throw new GenerationError(data.error || `Request failed: ${response.status}`, data.code);
  }

  return { content: data.content };
}
